// axios
import axios from 'axios'
import store from './store/store'
import router from './router'


window.axios = axios;

window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.headers.common["Access-Control-Allow-Headers"] = "*";
window.axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("token");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Content-Type"] = "application/json";
// window.axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
// window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

window.axios.defaults.baseURL = "https://api.ebtikar-innov.org/api/";

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    store.dispatch('logout')
    router.push('/login')
  }
  return Promise.reject(error)
});
